<template lang="pug">
div(
  style='padding: 32px 32px 16px 32px; width: 100%; border-bottom: 1px solid #e0e0e0; border-top: 1px solid #e0e0e0;')
  .titleLabel.colorDark
    | {{$t('conditions.ifTheWizardRecognizes')}}
  v-row(no-gutters style='width: 100%;')
    v-col(
      cols='12'
      v-for='(field, i) in assistantRec',
      :key='"conditions-" + i'
      style='align-self: flex-end')
      v-row(
        no-gutters
        style='justify-content: space-between; margin-top: 12px;')
        //- v-col(cols='2' style='padding: 0 8px 0 0;' )
        //-   v-select(
        //-     :ref='"selectFilter-" + i'
        //-     v-model='filter[i]',
        //-     :disabled='viewMode'
        //-     :items='filterItems'
        //-     placeholder="Filtro"
        //-     @change='comboboxKey++'
        //-     filled
        //-     dense
        //-     hide-no-data
        //-     background-color='rgb(244, 244, 244)'
        //-     color='#9c27b0'
        //-     style='border-radius: 0px'
        //-     )
        //-     template(v-slot:item='{ index, item }')
        //-       span(v-if='item.clickable', :style='{ color: item.color }')
        //-         | {{ item.text }} {{ item.filter }}
        //- v-text-field(
        //-   filled
        //-   dense
        //-   background-color='rgb(244, 244, 244)'
        //-   color='#9c27b0'
        //-   style='border-radius: 0px'
        //-   error-messages='Mensagem de ajuda'
        //- )
        v-col(:cols='showOperator(i) ? 9 : 11' style='padding: 0 8px 0 0;')
          md-field(:class='field.valid ? "" : "tribute__container"' style='margin-top: 0; background-color: none;')
            v-menu(
              :value="showMenu(i, field)"
              :close-on-click="false"
              :close-on-content-click="false"
              offset-y
              bottom
            )
              template(v-slot:activator="{ on, attrs }")
                vue-tribute(
                  :ref='"tribute-" + i'
                  :options='tributeOptions'
                  style='width: 100%;'
                )
                  input(
                    :class='!field.valid ? "tribute__border__error" : "tribute__border"'
                    :disabled='viewMode'
                    v-model='field.name'
                    :placeholder="$t('conditions.chooseCondition')"
                    class='tribute__input'
                    @keydown='inputKeydown(field, i)'
                    @change='update(field, i)'
                    @input='checkErrors(field)'
                    :ref='"input-tribute-" + i'
                    type='text'
                    @focus="inputFocus(i)"
                    @blur="inputBlur(i)"
                    @tribute-replaced='tributeSelected($event, field, i)'
                  )
                  span.tribute__helper(v-if='!field.valid') {{ field.msg }}
              v-list(:key='menu1Key' subheader v-if="field.name === ''")
                v-subheader(style='height: 40px; padding: 16px 0 0 8px; font-size: .75rem') {{$t('conditions.filterBy')}}
                v-list-item(@click='addFilter(field, "#", i)')
                  v-list-item-title(style='color: #ff9800') {{$t('conditions.intention')}}
                v-list-item(@click='addFilter(field, "@", i)')
                  v-list-item-title(style='color: #9c27b0') {{$t('conditions.entity')}}
                v-list-item(@click='addFilter(field, "$", i)')
                  v-list-item-title(style='color: #4caf50') {{$t('conditions.contextVariable')}}
                v-divider
                v-subheader(style='height: 40px; padding: 16px 0 0 8px; font-size: .75rem') {{$t('conditions.commonConditions')}}
                v-list-item(@click='addCommonConditions(field, "welcome", i)')
                  v-list-item-title welcome
                v-list-item(@click='addCommonConditions(field, "anything_else", i)')
                  v-list-item-title anything_else
              //- operator menu
              v-list(subheader v-else-if="selectOperator")
                v-subheader(style='height: 40px; padding: 16px 0 0 8px; font-size: .75rem') {{$t('conditions.operator')}}
                v-list-item(@click='addOperator(field, "", false, i)')
                  v-list-item-title any
                v-list-item(@click='addOperator(field, ":(", true, i)')
                  v-list-item-title : is
                v-list-item(@click='addOperator(field, " != ", false, i)')
                  v-list-item-title != is not
                v-list-item(@click='addOperator(field, " > ", false, i)')
                  v-list-item-title &gt; greater than
                v-list-item(@click='addOperator(field, " < ", false, i)')
                  v-list-item-title &lt; less than
              //- entity values menu
              v-list(subheader v-else-if="showValues" :class='selectedItem.values.length > 5 ? "scrollable-list" : ""')
                v-subheader(style='height: 40px; padding: 16px 0 0 8px; font-size: .75rem') {{$t('conditions.entityValues')}}
                v-list-item(v-for='value in selectedItem.values' @click='addValue(field, value.value, i)' :key="value.value")
                  v-list-item-title {{value.value}}
              //- intent examples menu
              //- v-list(subheader v-else-if="selectedItem && selectedItem.intent" :class='selectedItem.examples.length > 5 ? "scrollable-list" : ""')
              //-   v-subheader(style='height: 40px; padding: 16px 0 0 8px; font-size: .75rem') Valores da intenção
              //-   v-list-item(v-for='example in selectedItem.examples' @click='addValue(field, example.text)' :key="example.text")
              //-     v-list-item-title {{example.text}}
        v-col(v-if='showOperator(i)' cols='2')
          md-field(style='margin-top: 0')
            md-select(
              @blur='updateCondition(field, i)'
              v-model='field.operator'
              :disabled='viewMode'
              style='background-color: rgb(244, 244, 244); padding-left: 4px; padding-bottom: 4px')
              md-option(value='&&') AND
              md-option(value='||') OR
        v-col(style='margin-top: 8px;')
          span(
            v-if='i + 1 < assistantRec.length'
            @click='removeCondition(field, i)',
            :class='{ "disable-click": viewMode }')
            md-icon(
              style='cursor: pointer; color: blue; margin-bottom: 10px; padding-left: 24px;')
              | horizontal_rule
          span(
            v-else
            @click='addCondition',
            :class='{ "disable-click": viewMode }')
            md-icon(
              style='cursor: pointer; color: blue; margin-bottom: 10px; padding-left: 24px;')
              | add
</template>

<script>
import VueTribute from 'vue-tribute'
export default {
  model: {
    prop: 'conditions',
    event: 'update'
  },
  components: { VueTribute },
  props: {
    conditions: {
      type: String,
      default: () => '',
      required: true
    },
    customizedResponses: {
      type: Boolean,
      default: false
    },
    entities: {
      required: true,
      type: Array
    },
    intents: {
      required: true,
      type: Array
    },
    context: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      aux: 'Teste',
      menu: -1,
      selectOperator: false,
      selectedComparison: false,
      selectedItem: null,
      openBracket: false,
      comboboxKey: 0,
      menu1Key: 0,
      attAdd: '',
      valid: true,
      assistantRec: [],
      filter: [ '0' ],
      filterItems: [
        { header: this.$t('conditions.filterBy') },
        { text: '#', filter: 'Intenção', color: '#ff9800', clickable: true },
        { text: '@', filter: 'Entidade', color: '#9c27b0', clickable: true },
        {
          text: '$',
          filter: 'Variável de contexto',
          color: '#4caf50',
          clickable: true
        },
        {
          text: this.$t('conditions.noFilter'),
          value: 'none',
          clickable: true
        }
      ]
    }
  },
  computed: {
    viewMode () {
      return !this.$store.getters['snapshots/userCanEdit']
    },
    tributeOptions () {
      return {
        noMatchTemplate: function () {
          return this.$t('conditions.noResultsFound')
        },
        replaceTextSuffix: ' ',
        collection: [
          { // entities
            trigger: '@',
            lookup: 'entity',
            fillAttr: 'entity',
            values: this.entities
          },
          { // intents
            trigger: '#',
            lookup: 'intent',
            fillAttr: 'intent',
            values: this.intents
          },
          { // context
            trigger: '$',
            lookup: 'text',
            fillAttr: 'text',
            values: this.context
          }
        ]
      }
    },
    showValues () {
      return this.selectedItem && this.selectedItem.entity && !this.selectedComparison
    }
  },
  methods: {
    init () {
      if (this.assistantRec.length === 0) {
        this.assistantRec.push({
          name: '',
          value: '',
          operator: null
        })
      }
      this.updateAssistantRec({ name: this.conditions }, 0)
    },
    inputFocus (i) {
      setTimeout(() => {
        if (this.menu === -1 && this.lastMenu === i) {
          this.menu = i
        } else if (i !== this.menu) {
          this.menu = i
          this.selectOperator = false
          this.selectedItem = null
        }
      }, 300)
    },
    inputBlur (i) {
      setTimeout(() => {
        if (this.menu !== -1) {
          this.lastMenu = this.menu
        }
        this.menu = -1
      }, 300)
    },
    inputKeydown (field, i) {
      this.selectOperator = false
      this.selectedItem = null
      this.update(field, i)
    },
    addFilter (field, filter, index) {
      // function to return the index of the collection based on the filter
      let wichCollection = (filter) => {
        let activeCollection
        this.tributeOptions.collection.forEach((collection, i) => {
          if (filter === collection.trigger) {
            activeCollection = i
          }
        })
        return activeCollection
      }
      // set te v-model text
      this.$set(field, 'name', filter)
      // open the tribute menu
      this.$refs[`tribute-${index}`][0].tribute.showMenuForCollection(this.$refs[`input-tribute-${index}`][0], wichCollection(filter))
      // OLD STUFF
      // // make sure collection is the one we selected
      // this.$refs[`tribute-${index}`][0].tribute.current.collection = wichCollection(filter)
      // // even though we changed the current collection, the filteredItem are still old, so we gotta change too.
      // // since the first values are not filtered (no text typed to search),
      // // we can make it the default entities/intents/context_vars array
      // this.$refs[`tribute-${index}`][0].tribute.current.filteredItems = wichCollection(filter).values
      this.selectOperator = false
      this.selectedItem = null
      this.update(field, index)
    },
    addCommonConditions (field, condition, index) {
      this.$set(field, 'name', condition)
      this.selectOperator = false
      this.selectedItem = null
      this.update(field, index)
    },
    tributeSelected (event, field, index) {
      const mentionTrigger = event.detail.context.mentionTriggerChar
      this.selectedItem = event.detail.item.original
      if (mentionTrigger !== '@') {
        this.selectOperator = false
      } else {
        this.selectOperator = true
      }
      if (this.menu === -1) {
        this.menu = this.lastMenu
      }
      this.update(field, index)
    },
    addOperator (field, operator, openBracket, index) {
      // console.log(operator)
      if (operator === ' < ' || operator === ' > ') {
        this.selectedComparison = true
      } else {
        this.selectedComparison = false
      }
      if (field.name.endsWith(' ')) {
        this.$set(field, 'name', field.name.slice(0, -1) + operator)
      } else {
        this.$set(field, 'name', field.name + operator)
      }
      if (operator !== '') {
        this.openBracket = openBracket
        this.selectOperator = false
        this.$refs[`input-tribute-${index}`][0].focus()
        this.menu = index
      }
      this.update(field, index)
    },
    addValue (field, value, index) {
      const mentionValue = `"${value}"`
      this.$set(field, 'name', field.name + mentionValue + (this.openBracket ? ')' : ''))
      this.selectOperator = false
      this.selectedItem = null
      this.update(field, index)
    },
    showOperator (i) {
      const nextField = this.assistantRec[i + 1]
      return i !== this.assistantRec.length - 1 && nextField?.name
    },
    addCondition () {
      const lastField = this.assistantRec[this.assistantRec.length - 1]
      if (lastField.name) {
        lastField.operator = '&&'
        this.assistantRec.push({
          name: '',
          valid: true,
          value: '',
          operator: null
        })
      }
    },
    removeCondition (field, index) {
      // console.log(`removeCondition`, index)
      if (index === this.assistantRec.length - 1 && index !== 0) {
        const condIndex = this.assistantRec.length - 2
        this.assistantRec[condIndex].operator = null
      }
      this.assistantRec.splice(index, 1)
      this.update(field, index)
    },
    updateCondition (field, index) {
      // console.log('updateCondition::aqui')
      this.update(field, index)
    },
    update (field, index) {
      // console.log(`update`, index)
      setTimeout(() => {
        this.updateAssistantRec(field, index)
        const conditions = this.assistantRec
          .map((cond, i) =>
            this.showOperator(i) ? cond : { ...cond, operator: null }
          )
          .filter((cond) => cond.name)
          .map((cond, i) => `${cond.name} ${cond.operator || ''}`.trimRight())
          .join(' ')
        this.$emit('update', conditions)
      }, 100)
    },
    updateAssistantRec (condition, index) {
      const isOperator = (
        element,
        conditionsArr,
        conditionName,
        i,
        operator,
        antiOperator
      ) =>
        element === operator &&
        conditionsArr[i - 1] === operator &&
        conditionsArr[i - 2] !== operator &&
        conditionName !== operator &&
        conditionsArr[i - 2] !== antiOperator
      const assistantRecArr = []
      if (condition.name?.text) condition.name = condition.name.text
      const conditionsArr = [...(condition.name || '')] // transforma a string em array para podermos percorrer
      let conditionName = ''
      let bracketsInfo = { valid: true, msg: '' }
      for (let i = 0; i < conditionsArr.length; i++) {
        const element = conditionsArr[i]
        if (
          isOperator(element, conditionsArr, conditionName, i, '&', '|') ||
          isOperator(element, conditionsArr, conditionName, i, '|', '&')
        ) {
          // conditionName !== '&' é necessário pois se ele for igual
          // a apenas '&' significa que o conditionName é '&&' ex: this.conditions = '&& customCondition'
          // conditionsArr[i - 2] !== '&' é necessário para casos de múltiplos '&', ex: this.conditions = '&&&& cond1 &&& cond2'
          // deve resultar em '&&&& condition' AND '& true'
          // conditionsArr[i - 2] !== '|' é para que '||&& cond1' => '||&& cond1' e não '||' AND 'cond1' (FUNCIONAMENTO PADRÃO DO WATSON)
          // conditionsArr[i - 2] !== '|' é para que '|&& cond1' => '|&& cond1' e não '|' AND 'cond1' (FUNCIONAMENTO PADRÃO DO WATSON)
          // trocamos a condição de cima por conditionName !== '|&' se quisermos permitir ||&& => '||' OR &&
          conditionName = conditionName.slice(0, -1).trim()
          // removemos o último char do conditionName, pois ele é um '&' adicionado previamente
          // pois agora sabemos que se trata de um && (antes podia apenas ser um & sozinho)
          assistantRecArr.push({
            name: conditionName,
            value: '',
            operator: element === '&' ? '&&' : '||',
            valid: bracketsInfo.valid,
            msg: bracketsInfo.msg
          })
          bracketsInfo = { valid: true, msg: '' }
          conditionName = ''
          // removemos do nosso array o conteúdo já convertido
        } else if (element === '(') {
          let bracketsAns = this.checkBrackets(i, conditionsArr, conditionName)
          // passamos o "i" pois pode ter muito conteúdo antes dos parênteses e queremos checar
          // apenas a partir de quando os achamos
          conditionName = bracketsAns.conditionName
          bracketsInfo.valid = bracketsAns.valid
          if (!bracketsAns.valid) bracketsInfo.msg = bracketsAns.msg
          i = bracketsAns.endIndex
          // sempre vai dar a mensagem de erro se faltar fechar o parênteses
          // mas não necessariamente quando a semântica estiver incorreta
          // porém o seu funcionamento replica o Watson
          // '(false && (cond1 && cond2)) ((cond3)' inválido
          // '((cond3) (false && (cond1 && cond2))' inválido
          // '((cond1) ()) false)' válido

          // TODO caso em que ele encontra um parênteses ) com um () antes e.g: (opa) o )
        } else {
          conditionName += element
        }
      }
      if (conditionName.trim() !== '') {
        assistantRecArr.push({
          name: conditionName.trim() || '',
          value: '',
          operator: null,
          valid: bracketsInfo.valid,
          msg: bracketsInfo.msg
        })
      }
      // existe uma mínima diferença de funcionamento para o watson no caso:
      // 'cond1 &&&|| cond2' => 'cond1' AND '&' OR 'cond2' (nosso método)
      // => 'cond1' AND '&||cond2' (IBM Watson)
      if (assistantRecArr.length > 0) {
        assistantRecArr[assistantRecArr.length - 1].operator =
          condition.operator
        this.assistantRec.splice(index, 1, ...assistantRecArr)
        this.assistantRec[index].value = new Date().getTime() // force rerender
      }
      if (this.assistantRec.length > 1) {
        this.assistantRec = this.assistantRec.filter((cond) => cond.name)
      } else if (this.assistantRec.length === 1) {
        this.assistantRec[0].operator = null
      }
    },
    checkErrors (field) {
      // This key exists because the menu1 was not disappearing
      // When we clicked out the field, it desappears
      // But when we just write normally ignoring the menu1,
      // It shows forever untill we click outsite (or in the menu1)
      // Probably a reactivity issue because the vue doesn't
      // Remounts when we type something
      this.menu1Key++
      const result = this.checkBrackets(0, [...(field.name || '')], '')
      this.$set(
        field,
        'valid',
        result?.valid || typeof result?.valid === typeof undefined
      )
      this.$set(field, 'msg', result?.msg || '')
    },
    checkBrackets (i, conditionsArr, conditionName) {
      let bracketsCount = 0
      for (let j = i; j < conditionsArr.length; j++) {
        const item = conditionsArr[j]
        if (item === '(') {
          bracketsCount++
          conditionName += item
        } else if (item === ')') {
          bracketsCount--
          conditionName += item
          if (bracketsCount === 0) {
            return {
              conditionName,
              valid: true,
              msg: '',
              endIndex: j
            }
          }
        } else {
          conditionName += item
        }
      }
      if (bracketsCount > 0) {
        this.valid = false
        return {
          conditionName,
          valid: false,
          msg: this.$t('conditions.missingCloseParentheses'),
          endIndex: conditionsArr.length - 1
        }
      } else if (bracketsCount < 0) {
        this.valid = false
        return {
          conditionName,
          valid: false,
          msg: this.$t('conditions.missingOpenParentheses'),
          endIndex: conditionsArr.length - 1
        }
      }
      // no IBM Watson esse caso dá inválido:
      // '((false > (cond1 && cond2)))' alegando estar faltando parênteses
      // mas, se mudarmos para '((false && (cond1 && cond2)))' passa a ser válido
      // no nosso caso ambos seriam válidos pois não fazemos nenhuma verificação do conteúdo
      // interno aos parênteses
    },
    showMenu (i, field) {
      return this.menu === i && (field.name === '' || this.selectOperator || this.selectedItem || this.selectedItem?.entity)
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style>
.scrollable-list{
  height: 300px;
  overflow-y: auto;
}
.error--text {
  color: #ff5252 !important;
  caret-color: #ff5252 !important;
}

/* tribute css */
.tribute-container {
  position: absolute;
  top: 0;
  left: 0;
  height: auto;
  max-height: 300px;
  max-width: 660px;
  overflow: auto;
  display: block;
  z-index: 999999;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(#000, 0.13);
}
.tribute-container ul {
  margin: 0;
  margin-top: 2px;
  padding: 0;
  list-style: none;
  background: #fff;
  border-radius: 4px;
  border: 1px solid rgba(#000, 0.13);
  background-clip: padding-box;
  overflow: hidden;
}
.tribute-container li {
  /* color: #3f5efb; */
  padding: 5px 10px;
  cursor: pointer;
  font-size: 14px;
}
.tribute-container li.highlight,
.tribute-container li:hover {
  background: #9c27b0;
  color: #fff;
}
.tribute-container li span {
  font-weight: bold;
}
.tribute-container li.no-match {
  cursor: default;
}
.tribute-container .menu-highlighted {
  font-weight: bold;
}
/* TRIBUTE CUSTOM INPUT */
.tribute__input {
  background-color: rgb(244, 244, 244);
  font-size: 16px;
  height: 40px;
  font-family: inherit;
  width: 100%;
  border: 0;
  outline: 0;
  font-size: 1.3rem;
  color: rgba(0,0,0,.87);
  font-size: 16px;
  letter-spacing: normal;
  padding: 7px 12px;
  transition: border-color 0.2s;
}
.tribute__input:focus {
  padding-bottom: 6px;
  border-width: 2px;
  border-image-slice: 1;
}
.tribute__border {
  border-bottom: 1px solid rgba(0,0,0,0.42);
}
.tribute__border:focus {
  border-bottom: 2px solid rgb(156, 39, 176);
}
.tribute__border__error {
  border-bottom: 1px solid #ff5252
}
.tribute__border__error:focus {
  border-bottom: 2px solid #ff5252;
}
.tribute__helper {
  color: #ff5252 !important;
  caret-color: #ff5252 !important;
  font-size: 12px;
  padding-left: 12px;
}
/* DISABLE MD-FIELD BORDER-BOTTOM ON TRIBUTE */
.tribute__container:after {
  display: none;
}
.titleLabel {
  width: 100%;
  font-size: 20px;
  line-height: 30px;
}
</style>
